import {
  ICampaignOverviewSubmitData,
  ICampaignOverviewSubmitObject
} from "../../app/store/campaign/campaignOverview/types";
import SubmitDataBuilderFactory from "../../factories/campaigns/SubmitDataBuilderFactory";
import { CampaignConstants } from "../../constants/CampaignConstants";
import { AppState } from "../../app/store/rootReducers";
import CampaignBusinessRuleFacade from "../../rules/CampaignBusinessRuleFacade";

export default class CampaignOverviewSubmitObject implements ICampaignOverviewSubmitObject {

  action: string;
  data: ICampaignOverviewSubmitData;

  constructor(state: AppState) {
    this.action = this.getAction(state);
    const submitDataBuilder = SubmitDataBuilderFactory.create();
    this.data = submitDataBuilder.build(state.campaign.overview, this.action);
  }

  getAction(state: AppState) {
    // If the offer has p2p flag that is the ultimate rule
    if (state.campaign.overview.p2p) {
      return CampaignConstants.submitActions.P2P;
    }

    // If delivery options are applicable for offer submit action must be one of three (ELECTRO, PIS or STO)
    if (CampaignBusinessRuleFacade.isApplicableDeliveryOptions(state)) {
      switch (state.campaign.overview.deliveryOption) {
      case CampaignConstants.deliveryOptions.SOFT_ELECTRO:
        return CampaignConstants.submitActions.ELECTRO;
      // mbb campaign change for sending eanex
      case CampaignConstants.deliveryOptions.SOFT_EANEX:
        return CampaignConstants.submitActions.EANEX;
      case CampaignConstants.deliveryOptions.PIS:
        return CampaignConstants.submitActions.STORE;
      case CampaignConstants.deliveryOptions.STO:
        return CampaignConstants.submitActions.OTHER_ADDRESS;
      }
    }

    // If none of the previous are not applicable offer is from the WEBOS channel
    if (state.campaign.overview.cmUser.isAgent) {
      return CampaignConstants.submitActions.WEBOS_AGENT;
    }

    return CampaignConstants.submitActions.WEBOS;
  }

}
